import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const half = (
    <div className="flex w-max shrink-0 items-center">
      {t.marquee.items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-expanded whitespace-nowrap px-8 text-3xl font-black uppercase tracking-tight text-obsidian sm:px-12 sm:text-5xl">
            {item}
          </span>
          <span className="h-3 w-3 rotate-45 bg-obsidian" />
        </span>
      ))}
      <span className="font-display font-expanded whitespace-nowrap px-8 text-3xl font-black uppercase tracking-tight text-stroke sm:px-12 sm:text-5xl" style={{ WebkitTextStroke: "2px #0F172A" }}>
        {t.marquee.excluded}
      </span>
      <span className="h-3 w-3 rotate-45 bg-obsidian" />
    </div>
  );

  return (
    <section aria-hidden="true" className="overflow-hidden border-y border-obsidian bg-brand py-6 sm:py-8">
      <div data-testid="marquee-track" className="animate-marquee flex w-max">
        {half}
        {half}
      </div>
    </section>
  );
}
